import React from "react";
import { Button, Modal } from "react-bootstrap";
import './CompletionDialog.css';

export default function CompletionDialog(props) {

    return (
        <Modal id="ceCompletionDialog" show={props.show} onHide={props.handleClose} centered >
            <Modal.Header closeButton>
                <Modal.Title>
                    <div className="content-title">
                        <span>{props.intl.formatMessage({ id: "ce_dialog_header_info" })}</span>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <span>{props.intl.formatMessage({ id: props.message })}</span>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={props.handleClose}>{props.intl.formatMessage({ id: "header_close" })}</Button>
            </Modal.Footer>
        </Modal>
    );
};